import { queryClient } from '../../queryClient';
import Workspace from '../../types/Workspace';

export const updateSpaceQuery = (space: Workspace) => {
  queryClient.setQueryData(['workspace', Number(space.id)], () => {
    return space;
  });
};
